module.exports = __webpack_public_path__ + "static/media/icon_add_patient_checkbox_select.d9c0eb11.svg";